// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-menu {
  --min-width: 100%;
}
@media (min-width: 900px) {
  ion-menu {
    --min-width: 50% !important;
  }
}

.header {
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  margin-left: 50px;
}

.text {
  color: var(--ion-color-offset);
}

.background {
  --color: var(--ion-color-primary-contrast) !important;
  --background: var(--ion-color-primary) !important;
}

.profile-info-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 90%;
  margin: auto;
}

.portals-header-text {
  color: var(--ion-color-tertiary-contrast);
  margin-left: 10px;
  font-size: 20px;
  font-weight: bold;
}

.portal-logo {
  margin-left: 10px;
  height: 24px;
  color: var(--ion-color-tertiary-contrast);
  stroke: currentColor;
}

.navigation-button {
  width: 90%;
  height: 50px;
  display: flex;
  flex-direction: row;
  margin: 15px auto;
  font-weight: bold;
}

.portal-dropdown {
  width: 90%;
  --color: var(--ion-color-tertiary-contrast);
  box-shadow: none;
  margin: 15px auto;
}

.logo {
  margin: 5px;
  margin-right: 10px;
  margin-left: 15px;
  height: 20px;
  border-radius: 5px;
}

.portal-choice {
  display: flex;
  flex-direction: row;
  align-items: center;
  border: 1px solid var(--ion-background-contrast-color);
}

.navigation-icon {
  font-size: 22px;
  height: 50px;
  line-height: 50px;
  margin-left: 10px;
  stroke: currentColor;
}

.navigation-label {
  font-size: 20px;
  height: 50px;
  line-height: 50px;
  margin-left: 10px;
}

.logout-button {
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
  margin-bottom: 20px;
}
.logout-button ion-button {
  height: 30px;
}

.username {
  width: 100%;
  font-weight: bold;
  margin-left: 5px;
  font-size: 18px;
}

.avatar-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0;
}

.avatar {
  width: 50px;
  height: 50px;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;AACJ;AACI;EAHJ;IAIQ,2BAAA;EAEN;AACF;;AACA;EACI,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;AAEJ;;AACA;EACI,8BAAA;AAEJ;;AACA;EACI,qDAAA;EACA,iDAAA;AAEJ;;AACA;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,UAAA;EACA,YAAA;AAEJ;;AACA;EACI,yCAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;AAEJ;;AACA;EACI,iBAAA;EACA,YAAA;EACA,yCAAA;EACA,oBAAA;AAEJ;;AACA;EACI,UAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;AAEJ;;AACA;EACI,UAAA;EACA,2CAAA;EACA,gBAAA;EACA,iBAAA;AAEJ;;AACA;EACI,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;AAEJ;;AACA;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,sDAAA;AAEJ;;AACA;EACI,eAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,oBAAA;AAEJ;;AACA;EACI,eAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;AAEJ;;AACA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,mBAAA;AAEJ;AAAI;EACI,YAAA;AAER;;AAEA;EACI,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;AACJ;;AAEA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AACJ;;AAEA;EACI,WAAA;EACA,YAAA;AACJ","sourcesContent":["ion-menu {\r\n    --min-width: 100%;\r\n\r\n    @media (min-width: 900px) {\r\n        --min-width: 50% !important;\r\n    }\r\n}\r\n\r\n.header {\r\n    display: flex;\r\n    flex-direction: column;\r\n    text-align: center;\r\n    align-items: center;\r\n    margin-left: 50px;\r\n}\r\n\r\n.text {\r\n    color: var(--ion-color-offset);\r\n}\r\n\r\n.background {\r\n    --color: var(--ion-color-primary-contrast) !important;\r\n    --background: var(--ion-color-primary) !important;\r\n}\r\n\r\n.profile-info-container {\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    width: 90%;\r\n    margin: auto;\r\n}\r\n\r\n.portals-header-text {\r\n    color: var(--ion-color-tertiary-contrast);\r\n    margin-left: 10px;\r\n    font-size: 20px;\r\n    font-weight: bold;\r\n}\r\n\r\n.portal-logo {\r\n    margin-left: 10px;\r\n    height: 24px;\r\n    color: var(--ion-color-tertiary-contrast);\r\n    stroke: currentColor;\r\n}\r\n\r\n.navigation-button {\r\n    width: 90%;\r\n    height: 50px;\r\n    display: flex;\r\n    flex-direction: row;\r\n    margin: 15px auto;\r\n    font-weight: bold;\r\n}\r\n\r\n.portal-dropdown {\r\n    width: 90%;\r\n    --color: var(--ion-color-tertiary-contrast);\r\n    box-shadow: none;\r\n    margin: 15px auto;\r\n}\r\n\r\n.logo {\r\n    margin: 5px;\r\n    margin-right: 10px;\r\n    margin-left: 15px;\r\n    height: 20px;\r\n    border-radius: 5px;\r\n}\r\n\r\n.portal-choice {\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    border: 1px solid var(--ion-background-contrast-color);\r\n}\r\n\r\n.navigation-icon {\r\n    font-size: 22px;\r\n    height: 50px;\r\n    line-height: 50px;\r\n    margin-left: 10px;\r\n    stroke: currentColor;\r\n}\r\n\r\n.navigation-label {\r\n    font-size: 20px;\r\n    height: 50px;\r\n    line-height: 50px;\r\n    margin-left: 10px;\r\n}\r\n\r\n.logout-button {\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: center;\r\n    width: 100%;\r\n    margin-bottom: 20px;\r\n\r\n    ion-button {\r\n        height: 30px;\r\n    }\r\n}\r\n\r\n.username {\r\n    width: 100%;\r\n    font-weight: bold;\r\n    margin-left: 5px;\r\n    font-size: 18px;\r\n}\r\n\r\n.avatar-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n    margin: 0;\r\n}\r\n\r\n.avatar {\r\n    width: 50px;\r\n    height: 50px;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
